export default {
    LOAD_STORE_ORDERS (state, storeorders) {
        state.items = storeorders
    }
}